import { withAppCrashIfException } from 'epic';
import { navigateToSmartQuoteWorkspaceEpic } from 'epic/smart-quote/navigate-to-workspace';
import {
  parsingErrorStreamingEpic,
  parsingFinishedStreamingEpic,
  parsingResultStreamingEpic,
  parsingStartStreamingEpic,
  quoteResponseStreamingEpic,
  quoteResultEpic,
  resultsTotalCountStreamingEpic,
} from 'epic/smart-quote/parse-email-streaming';
import {
  clearSmartQuoteTabContentEpic,
  fetchSmartQuotePromptsEpic,
  fetchSmartQuoteTabsEpic,
} from 'epic/smart-quote/workspace-tabs';
import { combineEpics } from 'redux-observable';

export const smartQuoteEpic = () =>
  combineEpics(
    withAppCrashIfException(navigateToSmartQuoteWorkspaceEpic.name, navigateToSmartQuoteWorkspaceEpic()),
    withAppCrashIfException(fetchSmartQuoteTabsEpic.name, fetchSmartQuoteTabsEpic()),
    withAppCrashIfException(resultsTotalCountStreamingEpic.name, resultsTotalCountStreamingEpic()),
    withAppCrashIfException(parsingStartStreamingEpic.name, parsingStartStreamingEpic()),
    withAppCrashIfException(parsingResultStreamingEpic.name, parsingResultStreamingEpic()),
    withAppCrashIfException(parsingErrorStreamingEpic.name, parsingErrorStreamingEpic()),
    withAppCrashIfException(quoteResponseStreamingEpic.name, quoteResponseStreamingEpic()),
    withAppCrashIfException(parsingFinishedStreamingEpic.name, parsingFinishedStreamingEpic()),
    withAppCrashIfException(quoteResultEpic.name, quoteResultEpic()),
    withAppCrashIfException(fetchSmartQuotePromptsEpic.name, fetchSmartQuotePromptsEpic()),
    withAppCrashIfException(clearSmartQuoteTabContentEpic.name, clearSmartQuoteTabContentEpic()),
  );
